// The following are the components using this composable
// 1. TheHeroSection:
//    - Product Button Filtering (filteredProducts)
//    - Formulation BETA Tag
// 2. TheUpgradeSection:
//    - Show only when 'free' (rd_plg_freemium i.e. Eureka Freemium)

import { createSharedComposable } from '@vueuse/core';
import { packageInfoDeferred } from '@eureka/utils/package-info';
import { ref } from 'vue';

type MSE_PACKAGE =
  | 'material_pro' // 2026 PLG Pro
  | 'material_basic_free' // 2026 PLG Basic (Unused)
  | 'material_enterprise' // 2026 PLG Enterprise (Unused)
  | 'material_commercial_old' // Old Commercial -> Enterprise
  | 'material_commercial' // Old Commercial -> Enterprise
  | 'material_trial' // Old Trial -> Enterprise
  | 'material_trial_26' // 26 Trial -> Enterprise
  | 'rd_plg_freemium' // Eureka Freemium / Personal
  | 'ls_plg_personal_basic'; // Freemium

type PLAN_TYPE = 'enterprise' | 'pro' | 'free';

export const usePlan = createSharedComposable(() => {
  const currentPlan = ref<PLAN_TYPE | undefined>();

  const getPlan: () => Promise<PLAN_TYPE> = async () => {
    const res = await packageInfoDeferred.promise;
    const packages = res.map((p) => p.eureka_package) as MSE_PACKAGE[];

    if (
      packages.includes('material_commercial') ||
      packages.includes('material_commercial_old') ||
      packages.includes('material_enterprise') ||
      packages.includes('material_trial') ||
      packages.includes('material_trial_26')
    ) {
      return 'enterprise';
    } else if (packages.includes('material_pro')) {
      return 'pro';
    } else if (
      packages.includes('material_basic_free') ||
      packages.includes('rd_plg_freemium') ||
      packages.includes('ls_plg_personal_basic')
    ) {
      return 'free';
    }

    return 'free';
  };

  const setPlan = async () => {
    currentPlan.value = await getPlan();
  };

  return {
    currentPlan,
    getPlan,
    setPlan,
  };
});
